import React from 'react'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import type { Team, Step } from '../../types/session.types'
import { TeamProgressBar } from './TeamProgressBar'
import styles from './OtherTeamsSidebar.module.css'

export interface OtherTeamsSidebarProps {
  sessionId: string
  teams: Team[]
  stepsByTeam: Record<string, Step[]>
  className?: string
}

export function OtherTeamsSidebar({
  sessionId,
  teams,
  stepsByTeam,
  className,
}: OtherTeamsSidebarProps) {
  const navigate = useNavigate()

  return (
    <nav className={clsx(styles.sidebar, className)} aria-label="Other teams">
      <h3 className={styles.heading}>Other Teams ({teams.length})</h3>
      <div className={styles.list}>
        {teams.length === 0 ? (
          <div className={styles.empty}>No other teams</div>
        ) : (
          teams.map((team) => {
            const steps = stepsByTeam[team.id] ?? []
            const stepsTotal = steps.length
            const stepsDone = steps.filter((s) => s.status === 'done' || s.status === 'skipped').length
            const stepsFailed = steps.filter((s) => s.status === 'failed').length
            const progress = stepsTotal > 0 ? (stepsDone / stepsTotal) * 100 : 0
            const status = stepsFailed > 0
              ? 'failed'
              : stepsDone === stepsTotal && stepsTotal > 0
              ? 'done'
              : 'default'

            return (
              <button
                key={team.id}
                type="button"
                className={styles.compactCard}
                onClick={() => navigate(`/war-room/${sessionId}/team/${team.id}`)}
                aria-label={`${team.name}: ${stepsDone}/${stepsTotal} steps done`}
              >
                <div className={styles.cardHeader}>
                  <span className={styles.icon}>{team.icon || '👥'}</span>
                  <span className={styles.slug}>{team.slug.toUpperCase()}</span>
                  <span className={styles.stepCount}>
                    {stepsDone}/{stepsTotal}
                  </span>
                </div>
                <TeamProgressBar progress={progress} status={status} />
              </button>
            )
          })
        )}
      </div>
    </nav>
  )
}
